import React, { Component } from "react";
import { connect } from "react-redux";
import {
  View,
  StyleSheet,
  ScrollView,
  RefreshControl,
  Platform,
} from "react-native";
import Text from "../components_v2/TextFont";
import * as Actions from "../actions/UserMessageActions";
import { translate } from "../locales/translate";

import Theme from "../argon-ui/Theme";
import UserMessagePreview from "../components/UserMessagePreview";
import Loading from "../components_v2/Spinner";
import MessageBox from "../components_v2/MessageBox";
import {
  faCommentLines,
  faRedo,
  faTimes,
} from "../../assets/consts/faCharCodes";
import { ArButton } from "../argon-ui";
const axios = require("axios").default;

const isCloseToBottom = ({ layoutMeasurement, contentOffset, contentSize }) => {
  const paddingToBottom = 5;
  return (
    layoutMeasurement.height + contentOffset.y >=
    contentSize.height - paddingToBottom
  );
};

class UserMessagesScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isRefreshing: true,
      isLoading: true,
      errorMode: false,
      currentPage: 0,
      pageSize: 10,
      allowGetMore: true,
      newMessagesOnly: false,
      messages: [],
      accessToken: null,
      buildingId: null,
    };
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.UserMessages"),
  });
  apiUrl = (action) => {
    var _serverUrl = this.props.appReducer.serverUrl;
    if (_serverUrl.endsWith("/")) {
      _serverUrl = _serverUrl.slice(0, -1);
    }
    var apiUrl = `${_serverUrl}${action.url}`;
    return apiUrl;
  };
  async componentDidMount() {
    await this.getBuildingId();
    await this.getAccessToken();
    await this.getPage(1);

    await this.setAllSeen();
  }
  getAccessToken = async () => {
    const { accessToken } = this.props.appReducer?.currentServer;
    this.setState({ accessToken });
  };
  getBuildingId = async () => {
    const { buildingId } = this.props.appReducer?.currentBuilding;
    this.setState({ buildingId });
  };

  refreshData = async () => {
    this.setState({ messages: [] }, () => {
      // step 1: get new messages count again
      this.getNewMessagesCount();
      // step 2: get first page
      this.getPage(1);
    });
  };

  getNewMessagesCount = async () => {
    // set as seen only from visible items in this page
    if (!this.state.isRefreshing) {
      this.setState({ isRefreshing: true });
    }
    var action = Actions.getNewMessagesCount(
      this.state.accessToken,
      this.state.buildingId
    );
    var apiUrl = this.apiUrl(action);
    const buildingId = this.state.buildingId;
    try {
      var response = await axios.post(
        apiUrl,
        { buildingId },
        {
          timeout: 5000,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.state.accessToken}`,
          },
        }
      );
      // console.log(`list received by axios.get in getPage`, list.data);

      this.setState({
        isRefreshing: false,
      });

      let result = response.data;
      let { count } = result;

      this.props.setNewMessagesCount(count || 0);
    } catch (error) {
      console.log("error on UserMessagesScreen.setAllSeen", error);
      this.setState({ isRefreshing: false });
    }
  };

  getPage = async (page = 1) => {
    if (!this.state.allowGetMore && page > 1) return;
    if (!this.state.isRefreshing) {
      this.setState({ isRefreshing: true, errorMode: false });
    }
    var action = Actions.getList(
      page,
      this.state.pageSize,
      this.state.accessToken,
      this.state.buildingId
    );

    var apiUrl = this.apiUrl(action);
    try {
      var list = await axios.get(apiUrl, {
        timeout: 5000,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.state.accessToken}`,
        },
      });
      // console.log(`list received by axios.get in getPage`, list.data);
      this.setState({
        messages: [...this.state.messages, ...list.data],
        isRefreshing: false,
        isLoading: false,
        currentPage: page,
        allowGetMore: list.data.length >= this.state.pageSize,
      });
    } catch (error) {
      console.log("error on UserMessagesScreen.getPage", error);
      this.setState({
        isRefreshing: false,
        isLoading: false,
        allowGetMore: false,
        errorMode: true,
      });
    }
  };

  setSeen = async (messageId = "") => {
    // set as seen only from visible items in this page
    var message = this.state.messages.filter((m) => m.id == messageId)[0];
    if (!message || message.seen) return;

    if (!this.state.isRefreshing) {
      this.setState({ isRefreshing: true });
    }
    var action = Actions.markAsSeen(
      messageId,
      this.state.accessToken,
      this.state.buildingId
    );
    var apiUrl = this.apiUrl(action);
    const buildingId = this.state.buildingId;
    try {
      var response = await axios.post(
        apiUrl,
        { buildingId },
        {
          timeout: 5000,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.state.accessToken}`,
          },
        }
      );

      let result = response.data;
      let { count } = result;

      this.props.setNewMessagesCount(count || 0);

      let { messages } = this.state;
      for (const i in messages) {
        const message = messages[i];
        if (message.id == messageId) {
          message.seen = true;
          break;
        }
      }
      this.setState({
        messages: [...messages],
        isRefreshing: false,
      });
    } catch (error) {
      console.log("error on UserMessagesScreen.setSeen", error);
      this.setState({ isRefreshing: false });
    }
  };

  setAllSeen = async () => {
    // set as seen only from visible items in this page
    if (!this.state.isRefreshing) {
      this.setState({ isRefreshing: true });
    }
    var action = Actions.markAllAsSeen(
      this.state.accessToken,
      this.state.buildingId
    );
    var apiUrl = this.apiUrl(action);
    const buildingId = this.state.buildingId;
    try {
      var response = await axios.post(
        apiUrl,
        { buildingId },
        {
          timeout: 5000,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.state.accessToken}`,
          },
        }
      );
      // console.log(`list received by axios.get in getPage`, list.data);
      let { messages } = this.state;
      for (const i in messages) {
        const message = messages[i];
        if (!message.seen) {
          message.seen = true;
        }
      }
      this.setState({
        messages: [...messages],
        isRefreshing: false,
      });

      this.props.setNewMessagesCount(0);
    } catch (error) {
      console.log("error on UserMessagesScreen.setAllSeen", error);
      this.setState({ isRefreshing: false });
    }
  };
  renderRefreshBtn = () => {
    return (
      <View style={{ paddingHorizontal: 10 }}>
        <ArButton
          variant="outline"
          icon={faRedo}
          iconColor={Theme.COLORS.PRIMARY}
          onPress={() => {
            this.setState({ isLoading: true }, async () => {
              await this.getPage(1);
            });
          }}
        >
          {translate("userMessages.updateMessageRequest")}
        </ArButton>
      </View>
    );
  };
  renderTryAgainBtn = () => {
    return (
      <View style={{ paddingHorizontal: 10 }}>
        <ArButton
          variant="outline"
          icon={faRedo}
          iconColor={Theme.COLORS.PRIMARY}
          onPress={() => {
            this.setState({ isLoading: true }, async () => {
              await this.getPage(1);
            });
          }}
        >
          {translate("app.tryAgain")}
        </ArButton>
      </View>
    );
  };
  render() {
    var newMessages = this.props.userMessageReducer.newUserMessages; //this.state.messages.filter((m) => !m.seen).length;
    if (this.state.isLoading)
      return (
        <View style={{ flex: 1 }}>
          <Loading size={30} messageLoading={translate("app.loading")} />
        </View>
      );
    return (
      <View style={styles.container}>
        {/* === Error Mode  on UserMessagesScreen.getPage  */}
        {this.state.errorMode && (
          <View style={styles.noMessageContainer}>
            <MessageBox
              icon={faTimes}
              bgIconColor={Theme.COLORS.ERROR}
              shadowColor={Theme.COLORS.ERROR}
              renderButton={this.renderTryAgainBtn()}
            >
              {translate("userMessages.serverError")}
            </MessageBox>
          </View>
        )}
        {/* === Empty box message ==  */}
        {!this.state.errorMode &&
          newMessages == 0 &&
          this.state.messages.length == 0 && (
            <View style={styles.noMessageContainer}>
              <MessageBox
                icon={faCommentLines}
                renderButton={this.renderRefreshBtn()}
              >
                {translate("userMessages.noMessageYet")}
              </MessageBox>
            </View>
          )}
        <ScrollView
          onScroll={({ nativeEvent }) => {
            if (isCloseToBottom(nativeEvent)) {
              this.getPage(this.state.currentPage + 1);
            }
          }}
          style={styles.container}
          contentContainerStyle={{ paddingHorizontal: 5, marginTop: 5 }}
          //alwaysBounceVertical={true}
          fadingEdgeLength={20}
          scrollToOverflowEnabled={true}
          refreshControl={
            Platform.OS === "web" ? undefined : (
              <RefreshControl
                refreshing={this.state.isRefreshing}
                colors={[Theme.COLORS.TL_PURPLE]}
                onRefresh={this.refreshData}
              />
            )
          }
        >
          {this.state.messages.map((msg, i) => (
            <UserMessagePreview key={i} model={msg} />
          ))}
          {this.state.isRefreshing && (
            <View style={{ marginVertical: 5 }}>
              <Loading />
            </View>
          )}
        </ScrollView>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: { flex: 1 },
  topPanel: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    height: 60,
    padding: 10,
  },
  btnSeenAll: {
    backgroundColor: Theme.COLORS.SUCCESS,
    padding: 5,
    borderRadius: 5,
    justifyContent: "center",
    height: 30,
  },
  noMessageContainer: { flex: 1, padding: 10, marginTop: 10 },
});

const mapStateToProps = (state) => {
  return {
    userMessageReducer: state.UserMessageReducer,
    appReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    markAsSeen: (messageId, accessToken, buildingId) =>
      dispatch(Actions.markAsSeen(messageId, accessToken, buildingId)),
    markAllAsSeen: (accessToken, buildingId) =>
      dispatch(Actions.markAllAsSeen(accessToken, buildingId)),
    setNewMessagesCount: (count) => dispatch(Actions.setCountLocally(count)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserMessagesScreen);
